import { Overlay, Paper } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import { type PropsWithChildren } from 'react';

export default function OverOverlay({
  children,
  onClickOutsideOver,
  zIndex = 200,
  useEscapeToExit = true,
}: PropsWithChildren<{
  zIndex?: number;
  onClickOutsideOver?: () => void;
  useEscapeToExit?: boolean;
}>) {
  const clickOutsideRef = useClickOutside(() => {
    if (onClickOutsideOver) {
      onClickOutsideOver();
    }
  });

  return (
    <div className="overflow absolute inset-0 flex items-center justify-center">
      <Paper
        ref={clickOutsideRef}
        radius="md"
        className="animate-fadeIn relative p-4"
        style={{ zIndex: zIndex + 1 }}
        onKeyDown={(e) => {
          if (useEscapeToExit && e.key === 'Escape') {
            onClickOutsideOver?.();
          }
        }}
      >
        {children}
      </Paper>
      <Overlay zIndex={zIndex} />
    </div>
  );
}
